import {SPECIAL_BUILDING_TOKENS, TOKEN_NAME_MAPPING} from "../../../constants/tokens";
import {FORTRESS_MAX_DAMAGE} from "../../../configs/specialBuildings";
import {GOBLINS_FORTRESS_DAMAGE_PENALTY} from "../../../configs/factions/goblins";

/**
 * Единая точка правды для урона гоблина по строению: сколько урона нанесёт
 * успешная попытка и разрушит ли она строение. Используется и в reducer'е
 * ('FACTION_GOBLINS_DAMAGE_BUILDING', index.js) для применения урона, и на
 * клиенте (GameScene.js) ДО диспатча — чтобы показать верный тост ("повреждено"
 * vs "разрушено") и передать это описание другим клиентам через payload
 * (см. add-goblins-faction design.md Decision 17 - расхождение этого порога
 * с реальной механикой уже однажды приводило к багу, поэтому порог живёт
 * только здесь).
 *
 * Спецстроение (не крепость) разрушается порогом 2 - при этом теряет только
 * СЕБЯ (иконку), сам квартал под ним остаётся и получает отдельный, обнулённый
 * счётчик урона; крепость - порогом FORTRESS_MAX_DAMAGE.
 *
 * @param {Object} hexes
 * @param {Object} specialBuildings
 * @param {Object} buildingsDamage
 * @param {string} hexKey - цель
 * @param {number} roll - бросок д6 (используется только для крепости)
 * @returns {{damageIncrement: number, destroyed: boolean, buildingLabel: string}}
 */
export const calculateGoblinsBuildingDamageOutcome = (hexes, specialBuildings, buildingsDamage, hexKey, roll) => {
  const specialBuildingType = specialBuildings[hexKey];
  const isFortress = specialBuildingType === SPECIAL_BUILDING_TOKENS.FORTRESS;
  const damageIncrement = isFortress ? Math.max(0, roll - GOBLINS_FORTRESS_DAMAGE_PENALTY) : 1;
  const buildingLabel = TOKEN_NAME_MAPPING[specialBuildingType] || TOKEN_NAME_MAPPING[hexes[hexKey]] || 'строение';

  if (damageIncrement <= 0) {
    return {damageIncrement: 0, destroyed: false, buildingLabel};
  }

  const totalDamage = (buildingsDamage[hexKey] || 0) + damageIncrement;
  const destructionThreshold = isFortress ? FORTRESS_MAX_DAMAGE : 2;

  return {damageIncrement, destroyed: totalDamage >= destructionThreshold, buildingLabel};
};
